import { JobContent } from '@payaca/types/jobContentTypes';
import { Job } from '@payaca/types/jobTypesV2';
import { FunctionComponent, useEffect, type JSX } from 'react';
import { useDispatch } from 'react-redux';

import { getDealByJobId, getJob, getJobContent } from '@/utils/stateAccessors';
import JobOverview from './JobOverview';

import { useSelector } from '@/api/state';
import * as customerActions from '@payaca/store/customer/customerActions';
import * as dealsActions from '@payaca/store/deals/dealsActions';
import * as fileDownloadActions from '@payaca/store/fileDownload/fileDownloadActions';
import * as jobContentActions from '@payaca/store/jobContent/jobContentActions';
import * as jobPaymentActions from '@payaca/store/jobPayments/jobPaymentsActions';
import * as jobsActions from '@payaca/store/jobs/jobsActions';
import { Deal } from '@payaca/types/dealTypes';
import { FileDownloadTypes } from '@payaca/types/fileDownloadTypes';

type Props = {
  jobId: number;
  stickyTopClassName?: string;
};

const JobOverviewRetrievalWrapper: FunctionComponent<Props> = ({
  jobId,
  stickyTopClassName,
}: Props): JSX.Element => {
  const dispatch = useDispatch();

  const job: Job | undefined = useSelector((state) => {
    return getJob(state, jobId);
  });

  const jobContent: JobContent | undefined = useSelector((state) => {
    if (!job?.jobContentId) return;
    return getJobContent(state, job.jobContentId);
  });

  const deal: Deal | undefined = useSelector((state) => {
    return getDealByJobId(state, jobId);
  });

  useEffect(() => {
    dispatch(jobsActions.requestGetJobAttachmentsForJob(jobId));
    dispatch(
      fileDownloadActions.requestDownloadFile(
        jobId,
        FileDownloadTypes.QUOTE_SIGNATURE_IMAGE
      )
    );
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'dispatch', and 'jobId'
  }, []);

  useEffect(() => {
    if (job) {
      dispatch(dealsActions.requestGetDeal(job.dealId));
      dispatch(jobPaymentActions.requestGetJobPaymentsForDeal(job.dealId));

      dispatch(
        jobContentActions.requestGetJobContentWithJobGroupsAndJobLineItems(
          job.jobContentId
        )
      );
    }
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, [job]);

  useEffect(() => {
    if (jobContent) {
      jobContent.jobLineItemIds.forEach((jobLineItemId: number) => {
        dispatch(
          jobContentActions.requestGetJobLineItemAttachmentsForJobLineItem(
            jobLineItemId
          )
        );
      });
    }
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, [jobContent]);

  useEffect(() => {
    if (deal?.customerId) {
      dispatch(
        customerActions.requestGetAndSetCurrentCustomer(deal.customerId)
      );
    }
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, [deal]);

  return <JobOverview stickyTopClassName={stickyTopClassName} jobId={jobId} />;
};

export default JobOverviewRetrievalWrapper;
